import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'

import { seoPartnerScopedRouter } from './routing/seoPartnerScopedRouter'
import { seoAdminRouter } from './routing/seoAdminRouter'

import { seoRetailerAccessControl } from './access-control/seoAccess.configuration'
import { seoAdminAccessControl } from './access-control/seoAdminAccess.configuration'
import { Permission } from './access-control/permissions'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'seo',
  totem: {
    tool: 'seo-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [seoAdminRouter],
    partnerScoped: [seoPartnerScopedRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Manage SEO settings, starting with the robots.txt file that controls how search engines crawl the storefront',
          labelId: 'seoDomain.navLabel',
          route: 'seo-settings',
          accessControl: seoRetailerAccessControl,
          positionNavV3: 18,
          dividerBefore: true,
        },
      ],
    },
  ],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.Marketplace,
      subNavItems: [
        {
          route: 'app-admin-seo-settings',
          labelId: 'seoDomain.navLabel',
          accessControl: seoAdminAccessControl,
          inToolPermissions: [
            {
              slug: Permission.SeoMarketplaceModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.SeoMarketplaceModify,
            },
          ],
          positionNavV3: 11,
          dividerBefore: true,
        },
      ],
    },
  ],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
